import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var EquipmentsAttachmentsApi = /** @class */ (function () {
    function EquipmentsAttachmentsApi(apollo) {
        this.apollo = apollo;
    }
    EquipmentsAttachmentsApi.prototype.createEquipmentAttachment = function (input) {
        return this.apollo
            .query({
            query: gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        mutation createEquipmentAttachment($input: EquipmentAttachmentInput!) {\n          createEquipmentAttachment(input: $input) {\n            id\n            title\n            path\n            size\n            createdAt\n          }\n        }\n      "], ["\n        mutation createEquipmentAttachment($input: EquipmentAttachmentInput!) {\n          createEquipmentAttachment(input: $input) {\n            id\n            title\n            path\n            size\n            createdAt\n          }\n        }\n      "]))),
            variables: {
                input: input
            }
        })
            .pipe(map(function (response) { return response.data['createEquipmentAttachment']; }));
    };
    EquipmentsAttachmentsApi.prototype.updateEquipmentAttachment = function (id, input) {
        return this.apollo
            .query({
            query: gql(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n          mutation updateEquipmentAttachment($id: ID!, $input: EquipmentAttachmentInput!) {\n            updateEquipmentAttachment(id: $id, input: $input) {\n              id\n            }\n          }\n        "], ["\n          mutation updateEquipmentAttachment($id: ID!, $input: EquipmentAttachmentInput!) {\n            updateEquipmentAttachment(id: $id, input: $input) {\n              id\n            }\n          }\n        "]))),
            variables: {
                id: id,
                input: input
            }
        })
            .pipe(map(function (response) { return response.data['updateEquipmentAttachment']; }));
    };
    EquipmentsAttachmentsApi.prototype.deleteEquipmentAttachment = function (id) {
        return this.apollo
            .query({
            query: gql(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n          mutation deleteEquipmentAttachment($id: ID!) {\n            deleteEquipmentAttachment(id: $id) {\n              id\n            }\n          }\n        "], ["\n          mutation deleteEquipmentAttachment($id: ID!) {\n            deleteEquipmentAttachment(id: $id) {\n              id\n            }\n          }\n        "]))),
            variables: {
                id: id
            }
        })
            .pipe(map(function (response) { return response.data['deleteEquipmentAttachment']; }));
    };
    EquipmentsAttachmentsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EquipmentsAttachmentsApi_Factory() { return new EquipmentsAttachmentsApi(i0.ɵɵinject(i1.Apollo)); }, token: EquipmentsAttachmentsApi, providedIn: "root" });
    return EquipmentsAttachmentsApi;
}());
export { EquipmentsAttachmentsApi };
var templateObject_1, templateObject_2, templateObject_3;
